 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","1":"default~features-appointment-schedules-appointment-schedules-module~features-assignments-assignments~84e9a872","2":"default~features-appointment-schedules-appointment-schedules-module~features-booking-widget-booking-~e354c185","3":"default~features-appointment-schedules-appointment-schedules-module~features-booking-widget-booking-~681c50fb","4":"default~features-appointment-schedules-appointment-schedules-module~features-booking-widget-booking-~72775fce","5":"default~features-appointment-schedules-appointment-schedules-module~features-clinic-profile-clinic-p~aa11988b","6":"default~features-appointment-schedules-appointment-schedules-module~features-assignments-assignments~557d6722","7":"default~features-appointment-schedules-appointment-schedules-module~features-booking-widget-booking-~5dceacec","8":"default~features-appointment-schedules-appointment-schedules-module~features-booking-widget-booking-~b109b570","9":"default~features-appointment-schedules-appointment-schedules-module~features-clinic-profile-clinic-p~8829999c","11":"default~features-assignments-assignments-module~features-calendar-calendar-module~features-home-home-module","12":"default~features-clinic-search-clinic-search-module~features-home-home-module~features-search-search-module","13":"default~features-companies-companies-module~features-portal-notifications-portal-notifications-modul~000d6181","14":"default~features-appointment-schedules-appointment-schedules-module~features-clinic-profile-clinic-p~e66757ac","15":"default~features-clinic-search-clinic-search-module~features-search-search-module","16":"default~features-companies-companies-module~features-treatment-providers-treatment-providers-module","17":"canvg","18":"dompurify","19":"features-account-account-module","20":"features-appointment-schedules-appointment-schedules-module","21":"features-assignments-assignments-module","22":"features-bookings-bookings-module","23":"features-calendar-calendar-module","24":"features-clinic-profile-clinic-profile-module","25":"features-clinic-search-clinic-search-module","26":"features-companies-companies-module","27":"features-home-home-module","28":"features-login-login-module","29":"features-mitid-mitid-module","30":"features-notifications-notifications-module","31":"features-past-bookings-past-bookings-module","32":"features-portal-notifications-portal-notifications-module","33":"features-reports-reports-module","34":"features-search-search-module","35":"features-self-register-select-self-register-select-module","36":"features-settings-settings-module","37":"features-terms-and-conditions-terms-and-conditions-module","38":"features-treatment-providers-treatment-providers-module","39":"features-treatment-types-treatment-types-module","40":"features-users-users-module","41":"features-video-chat-video-chat-module","45":"self-register-self-register-module"}[chunkId]||chunkId) + "-es2015." + {"0":"957bc8a761b81822739c","1":"b735a4fb7336c04ea38e","2":"ac86f3788221dc18537e","3":"6e48e8b7a2d355be85b6","4":"9fd2c8facd9de0c7484a","5":"7d5c0393da913daa3c0c","6":"119e315c3d908338e38a","7":"d398f4be6233d4ea3774","8":"17b244159b36755be45d","9":"7b198f130cd046df5d01","11":"39f36354eeee7c45741a","12":"a6c187626d711ca43237","13":"998dd583e3413ee2a4a9","14":"7038250f798c10a3fb84","15":"25dca700c265a8506424","16":"6a0cad2a027cb661e4c6","17":"b73e053a87d9475b3759","18":"e8988ae758d41763f225","19":"2050c99dc99610cef4ef","20":"2ca5a2bdffa8fa0f068c","21":"6e896344a29e24f92993","22":"a4dd334dd23580331e83","23":"67417b5f1a6e87d35b6a","24":"16077ecac0c19b754af6","25":"b33a886d06107dba3901","26":"b79a6a6fb0febb0c46c8","27":"35787136fbdb9692ce79","28":"73fbc7bd772d1a3dc810","29":"348601c65bf9f1ec3e81","30":"82880b4159431054f386","31":"942c43bf1a80475092d7","32":"22aafb0d32ce39d4c9b2","33":"b6651838d95d85d87df7","34":"b3344511312fe2e96548","35":"4c2911b6cb770e2a4029","36":"5bf633d04deadfcc36a8","37":"c823f8626f72a607ffd2","38":"537ab94facda57e04857","39":"da3a0580e87fa97c79a3","40":"6310e46254d30c68ff52","41":"0a5f4033dc04e92099e8","45":"c9d32636db90cdbe4095"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
